import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSBC } from 'API/SBC/createSBC';

const useCreateSBC = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (sbcData) => {
        const response = await createSBC(sbcData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['SBCs', variables.locationID],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateSBC;
